/*
  Menú hamburguesa del header (ver snippets/kotashi-menu.liquid).
  Abre/cierra el panel de productos; se cierra con clic fuera, con Escape y al scrollear
  (el listener de scroll es pasivo y solo actúa si está abierto: coste cero el resto del tiempo).
*/

class KotashiMenu extends HTMLElement {
  connectedCallback() {
    this.boton = this.querySelector('[data-menu-boton]');
    this.boton?.addEventListener('click', this.#alternar);
    document.addEventListener('click', this.#alClicFuera);
    document.addEventListener('keydown', this.#alTeclear);
    window.addEventListener('scroll', this.#alScroll, { passive: true });
    // wheel y touchmove además de scroll: si el header sticky esconde la fila (o algún
    // contenedor hace scroll propio), el evento scroll de window puede no bastar.
    window.addEventListener('wheel', this.#alScroll, { passive: true });
    window.addEventListener('touchmove', this.#alScroll, { passive: true });
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.#alClicFuera);
    document.removeEventListener('keydown', this.#alTeclear);
    window.removeEventListener('scroll', this.#alScroll);
    window.removeEventListener('wheel', this.#alScroll);
    window.removeEventListener('touchmove', this.#alScroll);
  }

  #alternar = () => {
    if (this.classList.contains('is-abierto')) {
      this.#cerrar();
    } else {
      this.classList.add('is-abierto');
      this.boton?.setAttribute('aria-expanded', 'true');
      this.boton?.setAttribute('aria-label', 'Cerrar menú');
    }
  };

  #cerrar() {
    this.classList.remove('is-abierto');
    this.boton?.setAttribute('aria-expanded', 'false');
    this.boton?.setAttribute('aria-label', 'Abrir menú');
  }

  #alClicFuera = (evento) => {
    if (!this.contains(evento.target)) this.#cerrar();
  };

  #alTeclear = (evento) => {
    if (evento.key === 'Escape') this.#cerrar();
  };

  #alScroll = () => {
    if (this.classList.contains('is-abierto')) this.#cerrar();
  };
}

if (!customElements.get('kotashi-menu')) {
  customElements.define('kotashi-menu', KotashiMenu);
}
